<template>
  <b-form
    class="signUp"
    @submit.prevent="submitSignUp"
    novalidate
    >
    <div v-if='lastDash=="-LoyagU1QYSXEDcp9VIZ"' class=''>
      <h3>Welcome to the UF Green Job Platform.</h3>
        <p>
        We connect UF students and graduates to organizations and professionals in the Real Estate, Design and Construction Industries.
        <br>
        Go Gators.</p>
    </div>
    <div v-if='lastDash=="-LWDGKf7QhkwDDRqdmIg"' class=''>
        <h3>
        If this is your first time at the canvas enter your email and password below to register a new account.
        <br>
        If you are already using the canvas click Login to enter your email and password.
        </h3>
    </div>

    <b-form-group  v-if='lastDash=="-LWDGKf7QhkwDDRqdmIg"' class=''
      label="Registration Code:"
      label-for="code"
      >
      <b-form-input
        id="code"

        required
        placeholder="enter your code here"
        autocomplete="on"
        v-model="code"

        :disabled="authInProgress"
        >
      </b-form-input>

    </b-form-group>

    <b-form-group
      label="E-mail:"
      label-for="signUpEmailInput"
      >
      <b-form-input
        id="signUpEmailInput"
        type="email"
        required
        placeholder="example@domain.com"
        autocomplete="on"
        v-model.trim="$v.email.$model"
        :class="{ 'is-invalid': $v.email.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.email.required">E-mail field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.email.email && $v.email.required">
        E-mail field must contain valid E-mail address
      </b-form-invalid-feedback>
    </b-form-group>




    <b-form-group
      label="Password:"
      label-for="signUpPasswordInput"
      >
      <b-form-input
        id="signUpPasswordInput"
        type="password"
        required
        autocomplete="on"
        v-model.trim="$v.password.$model"
        :class="{ 'is-invalid': $v.password.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.password.required">Password field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.password.minLength && $v.password.required">
        Password must have at least {{$v.password.$params.minLength.min}} letters
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Password confirm:"
      label-for="signinPasswordConfirmInput"
      >
      <b-form-input
        id="signinPasswordConfirmInput"
        type="password"
        required
        invalid
        autocomplete="on"
        v-model="$v.passwordConfirm.$model"
        :class="{ 'is-invalid': $v.passwordConfirm.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.passwordConfirm.sameAsPassword">
        Passwords must be identical
      </b-form-invalid-feedback>
    </b-form-group>
    <div class="oauth" v-if="isUserAnonymous">
      <a
        href="#"
        class="oauth__link"
        @click.prevent="signUpAnonymousWithGoogle"
        v-b-tooltip.hover.top
        title="Sign up with Google"
        >
        <img src="@/assets/imgs/icons/google.svg" class="oauth__img" alt="Google">
      </a>
    </div>
    <div>
      <b-button
        variant="info"
        class="authForm__submit"
        type="submit"
        :disabled="authInProgress"
        >
        Submit
      </b-button>
    </div>
  </b-form>
</template>

<script>
// modules
import { mapState } from 'vuex'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
// services
import auth from '@/services/auth'
import db from '@/services/db'

export default {
  data () {
    return {
      email: '',
      password: '',
      code:'',
      passwordConfirm: '',
      lastDash:null
    }
  },
  computed: {
    ...mapState([
      'authInProgress',
      'isUserAnonymous',
      'userId'
    ])
  },
  mounted () {
    this.lastDash = localStorage.getItem('lastDash')
  },
  methods: {
    submitSignUp () {



      if (this.authInProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.$store.commit('addProcess', {
        process: 'signUp',
        message: 'Sign up'
      })
      this.$store.commit('destroyCasl')

      if (this.isUserAnonymous) {
        let data = {
          email: this.email,
          password: this.password,
          uid: this.userId
        }

        auth.signUpAnonymous(data, (err) => {
          this.$store.commit('deleteProcess', 'signUp')
          if (err) this.$store.commit('addError', err.message)
          else this.$router.push('/home')
        })
      } else {
        auth.signUp(this.email, this.password, (err) => {
          this.$store.commit('deleteProcess', 'signUp')
          if (err)
          {
            this.$store.commit('addError', err.message)
          }
          else {
            //is there a lastdashboard?
            const lastDash = localStorage.getItem("lastDash");

            if (lastDash) {

              if (lastDash == '-LWDGKf7QhkwDDRqdmIg' && 'IngenuityMatters,IngenuityNow'.includes(this.code) ){
                let name, email, template, disableInvites
                email = this.email
                name = this.email
                let signupCode = this.code

                if (signupCode == 'IngenuityNow') disableInvites = 'true'
                if (signupCode == 'IngenuityMatters') disableInvites = 'false'

                console.log('code is', signupCode, 'disable invites', disableInvites)
                //check type of invite login code

                // add canvas to canvas list and get its guid using
                // Generate a reference to a new location and add some data using push()
                var dbref = db.getDBRef('access/workspaces', true).push()
                email = email.toLowerCase()
                // Get the unique key generated by push()
                var workspaceKey = dbref.key

                var newWorkspace = {
                  dashboard: lastDash,
                  owner: this.userId,
                  name: name
                }

                dbref.update(newWorkspace)

                var inviteKey =
                  workspaceKey + '-' + email.replace(/[.]/g, '!').toLowerCase()

                var newInvite = {
                  [inviteKey]: {
                    email: email,
                    status: 'invited',
                    id: workspaceKey,
                    name: name,
                    disableInvites: disableInvites
                  }
                }
                db.getDBRef('access/workspaceAccess', true)
                  .update(newInvite)
              }
              else {
                this.$store.commit('addError', 'Invalid registration code please check the code and try again.')

              }

              




              console.log(fbUser)
              var rules = { value: 'read', text: 'Regular' }
              var loginID = this.userId
              db.access.saveDashboardAccess ({ loginID, lastDash, rules })
              console.log({ loginID, lastDash, rules })

              this.$router.push(`/dashboard/${lastDash}`);
            }
            else {
              console.log('sign up push to home')
              this.$router.push('/home')
            }


          }
        })
      }
    },
    signUpAnonymousWithGoogle () {
      this.$store.commit('addProcess', {
        process: 'signUp',
        message: 'Sign up'
      })
      this.$store.commit('destroyCasl')

      let data = {
        email: this.email,
        password: this.password,
        uid: this.userId
      }

      auth.signUpAnonymousWithGoogle(data, (err) => {
        this.$store.commit('deleteProcess', 'signUp')
        if (err) this.$store.commit('addError', err.message)
        else this.$router.push('/home')
      })
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    },
    passwordConfirm: {
      sameAsPassword: sameAs('password')
    }
  }
}
</script>
